import allocations from './allocations';
import fund from './fund';
import funds from './funds';
import { Router } from '@/legacy/Router';

Router.get('funding/allocation', allocations);
Router.get('funding/fund', funds);
Router.get('funding/fund/:any', fund);
